import type { Texture } from 'pixi.js';

export const isTextureLoaded = (texture: Texture): boolean =>
  texture.baseTexture.height > 0;
